import React from 'react';
import { IntlProvider } from 'react-intl';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import { Loading, ErrorBoundary, Notifications } from 'src/core/components';
import { routes as routeConstants, config } from 'src/constants';
import { getLoggedUserData, redirectToLogin } from 'src/utils';
import messages from 'src/i18n';
import { MCPPage } from 'src/pages';
import 'src/assets/sass/global.scss';

import './App.scss';

const AppRedirect = () => {
  redirectToLogin();

  return <Loading isLoading />;
};

const App = () => {
  const routes = [{ path: routeConstants.MCP_PAGE, component: MCPPage }];

  const user = getLoggedUserData();

  return (
    <IntlProvider
      key={user.locale}
      locale={user.locale}
      defaultLocale="en"
      messages={messages[user.locale]}
    >
      <ErrorBoundary>
        <Router basename={config.baseRoute}>
          <Switch>
            {routes.map((route) => (
              <Route
                key={route.path}
                path={route.path}
                exact
                component={!user.isAnonymous ? route.component : AppRedirect}
              />
            ))}
          </Switch>
        </Router>
        <Notifications />
      </ErrorBoundary>
    </IntlProvider>
  );
};

export default App;
